import { gql } from '@apollo/client'

export default gql(`
    mutation($type: String! $label: String! $id: ID! $isActive: Boolean $project: String) {
        updateMediaCategory(
            input: {
                id: $id
                type: $type
                label: $label
                isActive: $isActive
            },
            project: $project
        ) {
            id
            label
            type
            usageCount
            isActive
        }
    }`
)
